<template>
  <div class="hm">
    <div class="mainContainer hm-top-r" style="margin: 20px auto 42px;">
      <el-carousel height="334px">
        <el-carousel-item>
          <div>
            <img src="@/assets/images/20230206094610.png" style="width: 1200px;height: 334px;" />
            <div style="position: absolute;bottom: 80px;right: 80px;">
              <el-button type="success" round @click="toSbs(1)">查看详情</el-button>
              <el-button type="success" round @click="toSbs(2)">服务流程</el-button>
            </div>
          </div>
        </el-carousel-item>
        <el-carousel-item>
          <img src="@/assets/images/20230320174811.png" style="width: 1200px;height: 334px;" />
        </el-carousel-item>
        <!-- <el-carousel-item>
          <img src="@/assets/images/4407fc5c57d94d1f991a2078cc20a1c4.png" style="width: 1200px;height: 334px;" />
        </el-carousel-item>
        <el-carousel-item>
          <img src="@/assets/images/78e10c9f3c88ccd52df4bc50e71b60f2.png" style="width: 1200px;height: 334px;" />
        </el-carousel-item> -->
      </el-carousel>
    </div>
    <div class="mainContainer disFlex between">
      <div class="hm-hktjDiv">
        <div class="hm-sxTitle disFlex between">
          <span class="hm-sxTitle-l red">好课推荐</span><span class="hm-sxTitle-r" @click="toMore">查看更多</span>
        </div>
        <div class="disFlex between" style="flex-wrap: wrap;">
          <div v-for="k in hktjList" :key="k.id" class="hktj-every" @click="baoming(k.id)">
            <div class="hktj-every-bimg"><img :src="wjSrc+k.img" /></div>
            <div class="hktj-tit">{{k.cname}}</div>
          </div>
          <div class="hktj-every" v-if="hktjList.length>0" v-for="k in (3-hktjList.length%3)"
            style="visibility: hidden;">
          </div>
          <div class="hktj-every" v-if="hktjList.length==0" style="text-align: center;">
            <img style="margin: 50px auto 20px;" src="@/assets/images/nodata.png" />
            <div style="font-size: 18px;color: #999999;">暂无数据</div>
          </div>
        </div>
      </div>
      <div class="hm-rmphDiv">
        <div class="hm-sxTitle disFlex between">
          <span class="hm-sxTitle-l red">热门排行</span><span class="hm-sxTitle-r" @click="toMore">查看更多</span>
        </div>
        <div class="rmph-alldiv">
          <div v-for="(item,k) in hkphList" class="disFlex rmph-every" @click="baoming(item.id)">
            <div><img :src="wjSrc+item.img" />
              <div v-if="k<4" :class="'rmph-bq'+' rmph-bq'+k"></div>
            </div>
            <div class="rmph-every-r">
              <div class="rmph-every-r-t">{{item.cname}}</div>
              <div class="rmph-every-r-bm">{{item.buyamount}}人报名</div>
            </div>
          </div>
          <div v-if="hkphList.length==0" style="text-align: center;padding-bottom: 50px;width: 380px;"
            class="rmph-every">
            <img style="margin: 50px auto 20px;width: 63px;height: 42px;" src="@/assets/images/nodata.png" />
            <div style="font-size: 18px;color: #999999;">暂无数据</div>
          </div>
        </div>
      </div>
    </div>
    <div class="mainContainer disFlex between" style="margin: 55px auto;">
      <a href="http://www.tsanquan.com/" target="_blank"><img src="@/assets/images/4407fc5c57d94d1f991a2078cc20a1c4.jpg"
          style="width: 583px;height: 164px;border-radius: 4px;" /></a>
      <a href="http://www.gtzyws.com/" target="_blank"><img src="@/assets/images/hjbanner.png"
          style="width: 583px;height: 164px;border-radius: 4px;" /></a>
    </div>
    <!-- <div class="mainContainer disFlex between" style="margin: 55px auto;">
      <div class="gg-banner"><img src="@/assets/images/4407fc5c57d94d1f991a2078cc20a1c4.png" /></div>
      <div class="gg-banner"><img src="@/assets/images/4407fc5c57d94d1f991a2078cc20a1c4.png" /></div>
    </div> -->

    <div class="mainContainer">
      <div class="hm-sxTitle disFlex between">
        <span class="hm-sxTitle-l blue">科普宣传
          <span v-for="(item,i) in myzyjnList" :class="zyjnFlag==i?'active':''" @click="changeZyjn(i,item.uniqueCode)"
            :id="'zyjnListSpan'+i">{{item.text}}</span>

          <div class="huaxian" id="huaxian" style="left: 140px;"></div>
        </span><span class="hm-sxTitle-r" @click="toMore">查看更多</span>
      </div>
      <div class="disFlex" v-if="zyjnKclist.length>0" style="flex-wrap:wrap;">
        <div v-for="(k,z) in zyjnKclist" class="zyjn-every" style="height: 249px;" :key="k.id" :index="k.id" @click="toXjxq(k)"
          :style="z%4==3?'margin-right:0;':'margin-right:32px'">
          <div><img :src="wjSrc+k.imgPath" /></div>
          <div class="kcxc-every-tit">{{k.title}}【{{k.itypeName}}】</div>
        </div>
      </div>
      <div v-else style="height: 327px;background-color: #fff;text-align: center;">
        <img style="margin: 113px 0 20px;" src="@/assets/images/nodata.png" />
        <div style="font-size: 18px;color: #999999;">暂无数据</div>
      </div>
    </div>



    <div class="mainContainer" style="margin-bottom: 50px;">
      <div class="hm-sxTitle disFlex between">
        <span class="hm-sxTitle-l blue">专业职称考试
          <span v-for="(item,i) in myzyzcList" :class="zyzcFlag==i?'active':''" @click="changezyzc(i,item.uniqueCode)"
            :id="'zyzcListSpan'+i">{{item.text}}</span>

          <div class="huaxian" id="huaxianZyzc"></div>
        </span><span class="hm-sxTitle-r" @click="toMore">查看更多</span>
      </div>
      <div class="disFlex" v-if="zyzcKclist.length>0" style="flex-wrap:wrap;">
        <div v-for="(k,z) in zyzcKclist" class="zyjn-every" @click="baoming(k.id)"
          :style="z%4==3?'margin-right:0;':'margin-right:32px'">
          <div><img :src="wjSrc+k.img" /></div>
          <div class="zyjn-every-tit">{{k.cname}}</div>
          <div class="zyjn-every-yxq">有效期：{{k.endtime}}</div>
          <div class="zyjn-every-bot disFlex between"><span class="zyjn-every-bmrs">{{k.buyamount}}人报名</span>
            <span class="zyjn-every-price" v-if="k.price&&k.price>0">¥{{k.price}}</span>
            <span class="zyjn-every-mianfei" v-else>免费</span>
          </div>
        </div>
      </div>
      <div v-else style="height: 327px;background-color: #fff;text-align: center;">
        <img style="margin: 113px 0 20px;" src="@/assets/images/nodata.png" />
        <div style="font-size: 18px;color: #999999;">暂无数据</div>
      </div>
    </div>
  </div>
</template>

<script>
  import {
    getItype
  } from '@/assets/js/common.js';
  export default {
    name: 'Home',
    props: ['currentUser', 'isDenglu', 'wjSrc', 'zyzcList', 'zyjnList'],
    data() {
      var validatePhone = (rule, value, callback) => {
        if (value === '') {
          callback(new Error('手机号不能为空！'));
        } else if (!(/^1(3|4|5|6|7|8|9)\d{9}$/.test(value))) {
          callback(new Error('手机号码有误，请重新输入！'));
        } else {
          callback();
        }
      };
      return {
        hktjList: [],
        zyjnFlag: 0,
        zyzcFlag: 0,
        activeName: '001',
        lrkx: {
          margin: '0 15px 10px'
        },
        hkphList: [],
        zyjnKclist: [],
        zyzcKclist: [],
        myzyjnList: [],
        myzyzcList: []
      }
    },
    methods: {
      toSbs: function(flag) {
        if (flag == 1) {
          this.$router.push('/sbsda');
        } else {
          this.$router.push('/flow');
        }
      },
      getKclist: function(flag, itype) {
        var params = {
          page: 1,
          rows: 6,
          state: '1',
          isguoqi: 0
        };
        var url = '/kt/wz/productInfo/gettoplistPage.htm';
        // 好课推荐
        if (flag == '1') {
          params.ishot = '1';
        } else if (flag == '2' || flag == '3') {
          params.ontype = itype;
          params.rows = 4;
          if (flag == '2') {
            url = '/kt/productCourse/getlistPage.htm';
            params.nocid="1";
            delete params.ontype;
            params.itype = itype;
          }
        }
        this.$axios.get(url +'?'+ this.$qs.stringify(params), {
          headers: {
            "X-Requested-With": "XMLHttpRequest",
          }
        }).then(res => {
          var data = res.data;
          if (flag == '1') {
            this.hktjList = data.rows;
          } else if (flag == '2') {
            this.zyjnKclist = data.rows;
          } else if (flag == '3') {
            this.zyzcKclist = data.rows;
          }
        })
      },
      changeZyjn: function(flag, uniqueCode) {
        this.zyjnFlag = flag;
        var left1 = $('#zyjnListSpan' + flag).position().left;
        var left = left1 + ($('#zyjnListSpan' + flag).width() / 2);
        $('#huaxian').animate({
          left: left + 'px'
        });
        if (uniqueCode) {
          this.getKclist('2', uniqueCode);
        }
      },
      changezyzc: function(flag, uniqueCode) {
        this.zyzcFlag = flag;
        var left1 = $('#zyzcListSpan' + flag).position().left;
        var left = left1 + ($('#zyzcListSpan' + flag).width() / 2);
        $('#huaxianZyzc').animate({
          left: left + 'px'
        });
        if (uniqueCode) {
          this.getKclist('3', uniqueCode)
        }
      },
      getZyzcZd: function() {
        var $this = this;
        var data = JSON.parse(localStorage.getItem('zyzcList'));
        var myzyzcList = data;
        myzyzcList.unshift({
          'uniqueCode': 'ZXKT_producttype_3',
          'text': '全部'
        });
        this.myzyzcList = myzyzcList;
        setTimeout(function() {
          $this.changezyzc(0, 'ZXKT_producttype_2');
        }, 300);
      },
      getAqxj: function() {
        this.$axios.get('/system/datadict/tree.htm?supCode=ZXKT_KPXC&state=1', {
          headers: {
            "X-Requested-With": "XMLHttpRequest",
          }
        }).then(res => {
          var data = res.data;
          data.unshift({
            'uniqueCode': 'ZXKT_SAFETY_ITYPE',
            'text': '全部'
          });
          this.myzyjnList = data;
        })
      },
      baoming: function(id) {
        this.$router.push('/ProductDetail?id=' + id);
      },
      toXjxq: function(item) {
        if (item.fileType == '1') {
          this.$router.push('/Xjdetail?id=' + item.id);
        } else {
          window.open(this.wjSrc + item.filePath)
        }
      },
      // 跳转我的学习
      toLeaning: function() {
        this.$router.push('/Learning');
        this.$emit('changerouter', 5)
      },
      //好课排行
      getHkph: function() {
        var $this = this;
        var params = {
          page: 1,
          rows: 4,
          state: '1',
          isguoqi: 0
        };
        this.$axios.get('/kt/wz/productInfo/gettopbuylistPage.htm?' + this.$qs.stringify(params), {
          headers: {
            "X-Requested-With": "XMLHttpRequest",
          }
        }).then(res => {
          var data = res.data;
          this.hkphList = data.rows;
        })
      },
      toMore: function() {
        this.$router.push('/Product');
        this.$emit('changerouter', '2')
      }
    },
    created: function() {
      // 好课推荐列表
      this.getKclist(1);
      getItype(this.$axios, ((res) => {
        // 获取安全宣教
        this.getAqxj();
        // 获取专业职称字典
        this.getZyzcZd();
      }));
      // 好课排行
      this.getHkph();
      this.getKclist(3, '');
      this.getKclist(2, '');
    }
  }
</script>

<style>
  .hm-top-r {
    height: 334px;
    background-color: #D8D8D8;
    border-radius: 4px;
    margin-bottom: 42px;
  }

  .hm-hktjDiv {
    width: 742px;
  }

  .hm-sxTitle {
    margin-bottom: 38px;
  }

  .hm-sxTitle-l.red::before {
    content: " ";
    position: absolute;
    display: inline-block;
    width: 6px;
    height: 25px;
    background: #d50000;
    left: 0;
    top: 4px;
  }

  .hm-sxTitle-l.blue::before {
    content: " ";
    position: absolute;
    display: inline-block;
    width: 6px;
    height: 25px;
    background: #0071BA;
    left: 0;
    top: 4px;
  }

  .hm-sxTitle-l.blue span {
    display: inline-block;
    height: 20px;
    opacity: 1;
    font-size: 14px;
    font-family: 'PingFangSC';
    font-weight: 400;
    text-align: center;
    color: #333333;
    line-height: 20px;
    padding-left: 14px;
    cursor: pointer;
  }

  .hm-sxTitle-l.blue span.active {
    color: #0071ba;
  }

  .hm-sxTitle-l.blue .huaxian {
    position: absolute;
    width: 20px;
    height: 0px;
    opacity: 1;
    border: 2px solid #0071ba;
    left: 232px;
    bottom: -10px;
  }

  .hm-sxTitle-l {
    opacity: 1;
    font-size: 24px;
    font-family: 'PingFangSC';
    font-weight: 600;
    text-align: left;
    color: #333333;
    line-height: 33px;
    padding-left: 22px;
    position: relative;

  }

  .hm-sxTitle-r {
    font-size: 18px;
    font-family: 'PingFangSC';
    font-weight: 400;
    color: #9a9a9a;
    line-height: 33px;
    cursor: pointer;
  }

  .hktj-every {
    width: 233px;
    height: 185px;
    background: #ffffff;
    border-radius: 4px;
    box-shadow: 0px 2px 14px 0px rgba(0, 0, 0, 0.10);
    margin-bottom: 20px;
    cursor: pointer;
  }

  .hktj-every-bimg {
    width: 233px;
    height: 139px;
    opacity: 1;
    border-radius: 4px 4px 0px 0px;
    box-shadow: 0px 2px 14px 0px rgba(0, 0, 0, 0.10);
    position: relative;
    overflow: hidden;
  }

  .hktj-every .hktj-every-bimg img {
    width: 233px;
    height: 139px;
    position: absolute;
    top: 0;
    left: 0;
    transition: all 0.3s linear;
  }

  .hktj-every:hover img {
    transform: scale(1.2);
    /* opacity: 0.6; */
  }

  .hktj-every .hktj-tit {
    width: 212px;
    margin: 10px auto 0;
    opacity: 1;
    font-size: 16px;
    font-family: 'PingFangSC';
    font-weight: 500;
    color: #333333;
    line-height: 22px;
    text-align: left;
    text-shadow: 0px 2px 14px 0px rgba(0, 0, 0, 0.10);
  }

  .rmph-alldiv {
    padding: 20px 37px 0px 24px;
    opacity: 1;
    background: #ffffff;
    border-radius: 4px;
    box-shadow: 0px 2px 14px 0px rgba(0, 0, 0, 0.10);
  }

  .rmph-every {
    position: relative;
    cursor: pointer;
  }

  .rmph-bq {
    position: absolute;
    top: 0;
    left: 7px;
    width: 20px;
    height: 22px;
    opacity: 1;
    border-radius: 0px 0px 6px 0px 6px;
    font-size: 16px;
    font-weight: 800;
    color: #fff;
    text-align: center;
    cursor: pointer;
  }

  .rmph-bq.rmph-bq0 {
    background: url(../assets/images/ph1.png) 0 0 no-repeat;
  }

  .rmph-bq.rmph-bq1 {
    background: url(../assets/images/ph2.png) 0 0 no-repeat;
  }

  .rmph-bq.rmph-bq2 {
    background: url(../assets/images/ph3.png) 0 0 no-repeat;
  }

  .rmph-every img {
    width: 134px;
    height: 81px;
    opacity: 1;
    border-radius: 4px;
    margin-bottom: 26px;
  }

  .rmph-every-r {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    height: 81px;
    margin-left: 11px;
    width: 233px;
    text-align: left;
  }

  .rmph-every-r-t {
    width: 233px;
    height: 44px;
    opacity: 1;
    font-size: 16px;
    font-family: 'PingFangSC';
    font-weight: 500;
    color: #333333;
    line-height: 22px;
  }

  .rmph-every-r-bm {
    height: 20px;
    font-size: 14px;
    font-family: 'PingFangSC';
    font-weight: 400;
    color: #9a9a9a;
    line-height: 20px;
    letter-spacing: 1px;
  }

  .zyjn-every {
    width: 271px;
    height: 305px;
    opacity: 1;
    box-shadow: 0px 2px 14px 0px rgba(0, 0, 0, 0.10);
    background-color: #fff;
    transition: all 0.3s linear;
    cursor: pointer;
    margin-bottom: 15px;
  }

  .zyjn-every:hover {
    box-shadow: 0 10px 15px #E3E3E3;
    margin-top: -10px;
    transform: rotateY(10deg);
  }

  .zyjn-every img {
    width: 271px;
    height: 174px;
    opacity: 1;
    border-radius: 6px 6px 0px 0px;
    box-shadow: 0px 2px 14px 0px rgba(0, 0, 0, 0.10);
  }

  .zyjn-every-tit {
    margin: 10px auto;
    width: 252px;
    height: 22px;
    opacity: 1;
    font-size: 16px;
    font-family: 'PingFangSC';
    font-weight: 500;
    text-align: left;
    color: #333333;
    line-height: 22px;
    letter-spacing: 1px;
  }
  .kcxc-every-tit{
    margin: 10px auto;
    width: 252px;
    height: 44px;
    opacity: 1;
    font-size: 16px;
    font-family: 'PingFangSC';
    font-weight: 500;
    text-align: left;
    color: #333333;
    line-height: 22px;
    letter-spacing: 1px;
    overflow: hidden;
    text-overflow: ellipsis;
    -webkit-line-clamp: 2;
    display: -webkit-box;
    -webkit-box-orient: vertical;
  }

  .zyjn-every-yxq {
    width: 252px;
    height: 20px;
    opacity: 1;
    font-size: 14px;
    font-family: 'PingFangSC';
    font-weight: 400;
    text-align: left;
    color: #9a9a9a;
    line-height: 20px;
    letter-spacing: 1px;
    margin: 0 auto;
  }

  .zyjn-every-bot {
    width: 249px;
    margin: 10px auto 0;
    border-top: 1px solid #efefef;
    margin-top: 10px;
    line-height: 56px;
  }

  .zyjn-every-bot .zyjn-every-bmrs {
    font-size: 14px;
    font-family: 'PingFangSC';
    font-weight: 400;
    color: #9a9a9a;
    text-shadow: 0px 2px 14px 0px rgba(0, 0, 0, 0.10);
  }

  .zyjn-every-bot .zyjn-every-price {
    font-size: 24px;
    font-family: 'PingFangSC';
    font-weight: 500;
    text-align: right;
    color: #d50000;
    letter-spacing: 2px;
    text-shadow: 0px 2px 14px 0px rgba(0, 0, 0, 0.10);
  }

  .zyjn-every-bot .zyjn-every-mianfei {
    font-size: 24px;
    font-family: 'PingFangSC';
    font-weight: 500;
    color: #333333;
    letter-spacing: 2px;
    text-shadow: 0px 2px 14px 0px rgba(0, 0, 0, 0.10);
  }

  .gg-banner {
    width: 583px;
    height: 164px;
    border-radius: 4px;
  }

  .gg-banner img {
    width: 583px;
    height: 164px;
    border-radius: 4px;
  }
</style>



// WEBPACK FOOTER //
// src/components/Home.vue